import { deepFreeze } from '@/utils/deepFreeze';

export const TOGGLE_MAIN_SIDE_BAR = '[';
export const ALLOCATE_SELECTED_JOBS = 'F2';

export const comments = deepFreeze({
  TOGGLE_MAIN_SIDE_BAR: 'Toggle Main Sidebar',
  ALLOCATE_SELECTED_JOBS: 'Allocate Selected Jobs',
} as const);
